// prettier-ignore
/* eslint-disable @typescript-eslint/no-empty-interface */
const topLevelFields = {
  queries: {
    v13pTaxProviderGlobalSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Account: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountCapabilitiesCapability: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountEmailSettingsFetchAccountEmailSetting: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountEmailSettingsListAccountEmailSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountingAuditDetailSourceObjectId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountingJournalSummarizerConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountingJournalSummarizerDownload: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountingJournalSummarizerGet: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountingJournalSummarizerList: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountingMonthlyWaterfallV2SourceObjectId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountPersons: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1AccountRequirements: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountsAccount: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountsAccountCapabilities: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1AccountsAccountCapabilitiesCapability: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountsAccountExternalAccounts: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1AccountsAccountExternalAccountsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountsAccountInvoiceTaxInfoSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountsAccountPersons: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1AccountsAccountPersonsPerson: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountSecurityAnomalies: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1AccountSecurityAnomaliesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountStatusTaskId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountSuggestions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1AdaptivePricingDirectConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AdaptivePricingSubaccountConfigs: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1AdaptivePricingTemplateConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AddressReferenceCountryZipCode: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AgenticCommerceAgentConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AgenticCommerceChannels: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1AgenticCommerceSellerConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AgenticCommerceSellers: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1AgenticCommerceTurnkeySellerOnboardingSteps: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AjaxPaymentMethodConfigurations: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1AllCurrenciesFilter: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ApplePayDomains: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ApplicationFees: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ApplicationFeesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Applications: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ApplicationsApplicationToken: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ApplicationsLatest: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppLinksLinkId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppMarketplaceDevDashboardRecommendedApps: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ApprovalsApprovalRequestsDetailsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ApprovalsApprovalRequestsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ApprovalsApprovalRulesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ApprovalsApprovers: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ApprovalsListApprovalRequests: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ApprovalsListApprovalRules: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ApprovalsListApprovalRulesAction: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Apps: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1AppsAppConnection: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1AppsAppIdChannels: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1AppsAppIdDynamicClientApplications: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppsAppIdEligibilityForDistributionType: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppsAppIdInstalls: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1AppsInquiries: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1AppsInstallEligibility: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppsInstallsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppsSecrets: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1Asns: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AtlasAlternativeNames: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AtlasFundraisingBoardConsents: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AtlasPartners: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AtlasSafes: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AtlasTimelineEstimatesAndCompletionDates: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AutomationsRunsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AutomationsVersionId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AvailableBalancesForCurrencyConversion: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AvailablePaymentMethodsAndSources: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Balance: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BalanceEod: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BalancePendingCurrency: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BalanceSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BalanceSummary: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BalanceTransactions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BalanceTransactionsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BalanceTransfers: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BalanceTransfersBalances: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BalanceTransfersBalanceTransfer: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BankingOverrideableFeatureRestrictions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BankingPrivateAccountsFinancialAccountInstructionsPdf: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BankingPrivateAccountsFinancialAccountStatements: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BankingPrivatePlatformTransactionVolume: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BankSuggest: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingAlerts: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BillingAlertsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingCreditBalanceSummary: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingCreditBalanceTransactions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BillingCreditGrants: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BillingCreditGrantsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingFeedbackOptions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BillingMerchantTags: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingMeterEvents: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BillingMeterMerchantSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingMeterRatedUsageMetadata: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingMeters: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BillingMetersId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingOverviewMerchantSettingsVersion: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingOverviewUbbMerchantSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPaymentMethodConfiguration: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPolicyType: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalConfigurations: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BillingPortalRefundPolicies: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BillingPortalRefundPoliciesPrice: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BillingPortalRetentionFlows: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSession: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionCustomer: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionCustomerRecovery: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpCreditGrantBalance: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpCreditHistory: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpCreditNotesCreditNoteLines: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpInvoiceBalanceOverdue: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpInvoices: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpInvoicesInvoiceCreditNotes: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpInvoicesInvoiceLines: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpMeterUsage: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpSubscriptions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpSubscriptionsSubscription: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionPreviewCancel: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionPreviewReactivate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionUpdatePaymentMethod: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionUpdatePreview: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionUpdateTiers: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpUsageAnalytics: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionInvoiceRecovery: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionInvoices: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionInvoicesSearch: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionLinkPaymentMethodPaymentMethod: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionPaymentMethods: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionPaymentMethodsPaymentMethod: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionPricingPlanSubscriptions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionPricingPlanSubscriptionsPricingPlanSubscriptionId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSubscriptions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscription: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionCheckRefundEligibility: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionRetentionCoupon: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionRetentionFlowCoupon: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSubscriptionUpdatePaymentMethodLink: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionUpdatePreview: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionValidatePromotionCode: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BulkOnboardingExternalAccountsForLeAndMerchants: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BulkOnboardingGetAccountsForBulkOnboardingMerchants: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BulkOnboardingLegalEntitiesAccessibleForUserAndMerchants: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BuyButtonsForPlink: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalActionRequired: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CapitalActiveOnlineThirdPartyIntegrations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalAdditionalUnderwritingRequest: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalAdditionalUnderwritingRequests: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CapitalBankAccounts: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CapitalConnectContract: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalConnectPartnerPrograms: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalDualMerchantFinancings: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CapitalDualMerchantFinancingsDualMerchantFinancing: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalFinancingAccepted: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CapitalFinancingBalanceFinancingOffer: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalFinancingMultiDrawFinancingLine: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalFinancingMultiDrawFinancingLines: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CapitalFinancingOfferCounts: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalFinancingOfferSneakPeek: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalFinancingOffersOnDemand: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalFinancingOfferUpsell: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalImports: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CapitalImportsImportBundle: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalLendingNetworkCreatePartnerApplicationWorkflowStatus: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalMerchantRevenue: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalMerchantSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalNoOfferPotentialOfferSize: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalOfferApplicationsOfferApplication: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalOffers: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CapitalOffersOffer: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalOffersOfferCalculations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalPlatformPortfolioUnderwritingTimeSeries: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CapitalPlatformsMerchantSettings: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CapitalPlatformsMerchantSettingsMerchant: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalPlatformsPlaygroundSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalSbfeConsent: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalYouLendAcceptanceWorkflow: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalYouLendEligibleSigners: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalYouLendRepayment: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CashAdvances: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CashAdvancesCashAdvance: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Charges: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ChargesCharge: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CheckoutInspectDetails: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CheckoutSessions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CheckoutSessionsSession: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CheckoutSessionsSessionLineItems: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ClimateAutogenDraftSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateAutogenLiveSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateBrandSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateCacheValues: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateConnectPlatformConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateOrders: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ClimateOrdersOrder: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateOrderSummary: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateProducts: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ClimateProductsProduct: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateProgram: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateSignupPricePoints: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ClimateSignupState: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateSuppliers: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ClimateSuppliersSupplier: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CommunicationChannels: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CommunicationManagementListEmailDestinations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CommunicationManagementListSubscriptionRecipients: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CommunicationPreferences: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ConnectAccountGroups: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAccountGroupsCsvValidate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAccountReadyToOnboard: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAccountsConnectedAccountDetails: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAccountsV2GetPlatformPublicPreviewState: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAccountsV2GetV1CustomerProjectionStatus: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAccountsV2GetV2AccountsFasttrackState: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAgenticCommerceConfigSubaccountConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAgenticCommerceConfigTemplateConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectCommsCenterCsvSummaryStatus: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectCommsCenterEmailPreview: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectCommsCenterPlatformCommunicationsTemplate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectCommsCenterProductCommunicationSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectCommsCenterProductCommunicationSettingsAll: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectCommsCenterProductCommunicationSettingsEmails: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectCommsCenterSentEmail: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectCommsCenterSentMessagesToConnectedAccount: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ConnectCommsCenterUrls: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ConnectConnectedAccountEligibleAdditionalVerifications: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectConnectedAccountsListAggregations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectDebitCardCountrySupported: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectEligibleForIdentityAuth: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectExternalAccountCollectionConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectFinancialAccounts: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ConnectFinancingFinancingTransactions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ConnectGrossSettlementConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectIdentityChallengesAuthAttemptIdExternalAccountKey: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectInsightsDashboardConfiguration: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectInsightsDashboardConfigurationForMerchant: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectInsightsQueryAggregatedCurrentUserTasks: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectInsightsUpcomingUserTasksByMonthAggregation: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectInstantPayoutsConfig: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ConnectIntegrationPlatformAttestation: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectInvitations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectionsAccounts: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ConnectionsFeaturedInstitutions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ConnectionsInstitutions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ConnectionsOffers: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ConnectLegalEntitiesAccessibleForUserAndMerchant: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ConnectLegalEntitySharingAllowed: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectNoCodeInstantPayoutsSubaccountConfigConnectedAccountId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectNoCodeInstantPayoutsTemplateConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectNoCodeMeetsInstantPayoutsEligibilityPnblConnectedAccountId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectOnboardingConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectPayoutMethodCollectionConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectPayoutsInstantPayoutsPricing: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectPayoutsNoCodeInstantPayoutsInstantPayoutSupportedCountriesPnbl: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectPlatformCadDetails: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectPricingGroupsCustomizedPricingGroup: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectPricingGroupsSubaccountPricingGroup: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectPricingGroupsTemplates: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectRisk: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ConnectRiskAndComplianceSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectSession: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectTaxReportingUsTaxFormRequestLatest: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectUnderwritingRequests: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ConnectUser: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectW8W9CollectionFullyKeyedInTaxId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectW8W9CollectionPdfConnectedAccountId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectW8W9CollectionRomajiInfo: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectW8W9CollectionW8Settings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectW8W9CollectionW8W9PlatformConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConsoleConversations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConsoleConversationsConversationId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConsoleDebugPrompt: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConsoleMerchantContext: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConsoleSkills: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConsoleSkillsName: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConsoleTaskId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ControlledContentBatchDisplayStatus: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ControlledContentDisplayStatus: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ControlledContentSurfaceDisplayStatus: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CountrySpecsCountry: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Coupons: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CouponsCoupon: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CreditNotes: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CreditNotesCreditNoteLines: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CreditNotesPreview: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CreditNotesPreviewLines: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CryptoInternalPayinSession: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CryptoInternalSetupSession: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CryptoInternalWalletBalances: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CryptoPayoutsSupportedCryptoNetworks: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CurrencyConversionsConversion: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CurrentMerchant: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomDomainsTypeType: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomerCashBalanceCurrencyEnablementDetails: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomerCashBalanceEnabledCurrencies: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Customers: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CustomersBlockedBillingAddressCountries: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomersCustomer: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomersCustomerBalanceTransactions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CustomersCustomerCashBalanceTransactions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CustomersCustomerCashBalanceTransactionsTransaction: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomersCustomerFundingInstructions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CustomersCustomerPaymentMethodsPaymentMethod: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomersCustomerSources: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CustomersCustomerTaxExemptions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CustomersCustomerTaxExemptionsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomersCustomerVbanOwnershipLetter: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomerSegmentationCharts: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomerSegmentationChartsChart: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomerSegmentationDashboards: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomerSegmentationDashboardsDashboard: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomerSegmentationSavedSegments: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomerSegmentationSavedSegmentsSavedSegment: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomersSearch: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DashboardMobileUiWhatsNew: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DashboardSearch: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1DashboardSettingsBillingMode: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DashboardSettingsBillingNotifications: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DashboardSettingsSubscriptionProration: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DashboardVolumeLimits: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DashboardWidgetsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DataExplorerEditableGroups: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DataExplorerGroups: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DataExplorerMetricsMetric: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DataManagementImportSetsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DataStudioBillingCount: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DataStudioTrialEligibility: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DebitAgreements: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputeEvidenceSubmissionsSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Disputes: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1DisputesDispute: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesInternalArbitrationSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesInternalAutoRepresentmentDisputeFeePassthroughUsageFeeSummary: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesInternalAutoRepresentmentGetMerchantConfiguration: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesInternalAutoRepresentmentSettingDirectConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesInternalAutoRepresentmentSettingSubaccountConfigs: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1DisputesInternalAutoRepresentmentSettingTemplateConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesInternalEnrichedDisputes: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesInternalEvidenceLibrary: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesInternalIssuerEvidence: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesInternalPreventionListMerchantSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesInternalPreventionListPreventionEnrollments: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EarningsChart: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EmbeddedPaymentDetailSummary: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EmbeddedTransactionsSummary: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EmeraldTransactions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1EnterpriseProjectsBulkPromoCodesGetAllExecutions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EnterpriseProjectsBulkPromoCodesGetCurrentExecution: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EnterpriseProjectsBulkPromoCodesGetDownloadUrl: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EntitlementsActiveEntitlements: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1EntitlementsFeatures: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1EntitlementsFeaturesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Events: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1EventsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ExperienceEngineNocodeModules: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ExportDetailsObject: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ExportDownloadExportId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ExportExportId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FacilitatedCommercePermissionGrants: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1FacilitatedCommerceProducts: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1FacilitatedCommerceProductsSearch: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1FaEligibilityCheckResult: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FeeCreditsGetCredit: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FeeCreditsListCredits: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FileLinksLink: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Files: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1FilesFile: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FinancialConnectionsAccounts: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1FinancialConnectionsAccountsAccount: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FinancialConnectionsAccountsAccountBalanceActivity: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1FinancialConnectionsRefreshes: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1FinancialConnectionsSessions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1FinancialConnectionsSessionsSession: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FinancialConnectionsSessionsSessionEvents: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1FinancialPartnerPaymentAuthorizationsPaymentAuthorization: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FinancialReportingOrganizationAccountsCurrencies: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FinancialReportingOrganizationAccountsMetadata: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FinancialReportingOrgPlatformAggregations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FinancingFinancingTransactions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1FinancingReviewsFinancingObject: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FinancingTransactions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1FinancingTransactionsFind: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FinancingTransactionTransaction: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FlexLoans: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1FlexLoansFlexLoan: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FlexLoansFlexLoanMinRepaymentWindows: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1FlexLoansFlexLoanRetrieveAgreement: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FrMealVouchersSiretInfo: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1GetCompliancePdfPollToken: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1GiftCardsCards: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1GiftCardsCardsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1GiftCardsTransactions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1GuestCustomerForPayment: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1GuestCustomers: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1GuestCustomersGuestCustomer: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IamRoleAssignmentsPrincipal: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IdentityVerificationReports: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1IdentityVerificationSessions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1IdentityVerificationSessionsSession: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IdentityVerificationTemplates: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1IdentityVerificationTemplatesTemplate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InternalRubyReadFirst: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Inventories: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1InventoriesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InviteATeammateInvites: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoiceChallengesSiteKey: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Invoiceitems: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1InvoiceitemsInvoiceitem: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoicePayments: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1InvoiceRenderingTemplates: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1InvoiceRenderingTemplatesTemplate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Invoices: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1InvoicesInvoice: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoicesInvoiceEmailSubjectData: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoicesInvoiceLines: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1InvoicesInvoicePayments: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1InvoicesInvoiceRevisions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1InvoicesInvoiceSummaryItems: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1InvoicesPreview: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoicesUpcoming: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoicesUpcomingLines: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1IpGeocode: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingAccountSettingFlags: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingAftenrollmentPricingstatus: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingAftenrollmentUserconfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingAuthorizations: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1IssuingAuthorizationsAuthorization: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingCardholders: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1IssuingCardholdersCardholder: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingCards: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1IssuingCardsCard: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingDisputes: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1IssuingDisputesDispute: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingEmbeddedFlags: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingLiveModeTrialControls: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingPersonalizationDesigns: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1IssuingPersonalizationDesignsPersonalizationDesign: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingPhysicalBundles: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1IssuingPhysicalBundlesPhysicalBundle: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingPrograms: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1IssuingProgramsList: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1IssuingProgramsProgram: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingProgramsRetrieveProgram: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingReceipts: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1IssuingReceiptsReceipt: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingRulebacktest: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingTransactions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1IssuingTransactionsTransaction: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IsUrlOptOutMerchant: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1JapanAddressSuggest: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ListLegacyChargesSearch: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1LiveModeTrial: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1LpmAdoptionPaymentMethodRecommendedBuyerCountries: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1LpmDashboardSettingsFinancingPackageDetailsAffirm: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1LpmPartnerSettlementAndConversationsSettlement: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1LtmAlwaysOnEligibility: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ManagedOperationsCampaigns: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ManagedOperationsCancellationReasons: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ManagedOperationsMerchantSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ManagedPaymentsAccountEligibility: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ManagedPaymentsEligibleTaxCodes: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ManagedPaymentsMerchantSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Mandates: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1MerchantEligibilityForPiiExemptOnboardingMerchantId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1MetadataKeys: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Metrics: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1MexicoAddressSuggest: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1MexicoAddressSuggestNested: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1MonetizationCurrentPricing: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1MoneyManagementBalanceSummary: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1MoneyManagementFuturePayouts: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1MoneyManagementMerchantAttributes: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1MoneyManagementOutboundPaymentFees: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Notes: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1NtaCorporateNumberTypeahead: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1OnboardingBusinessIntentRecommendations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1OrdersIdLineItems: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1OrrChanges: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1OrrGroups: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1OrrMetrics: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1OtpSmsDeliveryHealthy: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaperChecks: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1PaperChecksId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentAttemptRecordEntriesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentAttemptRecordsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentAttemptRecordsIdEntries: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1PaymentIntents: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1PaymentIntentsIntent: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentIntentsWithLegacyCharges: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1PaymentLinks: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1PaymentLinksPaymentLink: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentLinksPaymentLinkLineItems: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1PaymentMethodConfigurations: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1PaymentMethodConfigurationsConfiguration: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentMethodDomains: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1PaymentMethods: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1PaymentMethodsPaymentMethod: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentMethodSupportedCurrencies: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentOptimizerSelfServeEligibility: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentOptimizerTrials: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1PaymentOrchestrationRoutingOnboardedProcessors: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentOrchestrationRoutingRoutingConfigs: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1PaymentProviderBalanceTransactions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1PaymentRecordsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentsConfigPaymentMethodsUsBankAccount: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentsConfigPaymentsVolumes: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Payouts: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1PayoutsCurrencyCurrency: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1PayoutsPayout: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PayoutsPayoutSummary: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PayoutsSettingsBankToPayoutReconciliation: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PersonVerificationRequest: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1PlatformExtensionAccountStatusPreview: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PlatformExtensionDisruptedExtensions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PlatformExtensionPreviewConnectedAccount: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PlatformOnboardingVerificationStatus: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PmonboardingPmonboardingForm: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Prices: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1PricesPrice: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PricesPriceSubscriptionCount: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PricingConfigsPricingType: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PricingConfigsPricingTypeSchemesCurrentAt: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PricingTables: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1PricingTablesPricingTable: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProductCatalogFeedIngestedAndSyndicatedCounts: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProductCatalogFeedProducts: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProductCatalogFeedProductsSku: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProductCatalogMetadata: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProductCatalogTrialOffers: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ProductCatalogTrialOffersId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProductClasses: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ProductClassesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProductFeatures: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1Products: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ProductSetupStatus: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProductsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProductsProductFeatures: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ProductSuggestions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1Profiles: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProfilesAlerts: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProfilesFinancialAccountTransfersConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProfilesFinancialAccountTransfersNetworkIdConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProfilesProposal: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProfilesSearch: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ProfilesUsernameStatusUsername: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProfilesUsernameUsername: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Quotes: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1QuotesQuote: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarAgenticInsights: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarCustomCountersConfiguration: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarExpandGraph: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarMerchantRulesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarMerchantRulesMerchantRuleIdFanoutsFanoutId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarPaymentEvaluations: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1RadarPaymentEvaluationsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarRetrieveAttributeValues: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarRetrieveFraudAlerts: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1RadarRetrieveRadarSupportedPaymentMethods: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarSearchPredicateDetailMetrics: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarSearchRulesDisputeMetrics: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarSearchRulesDisputes: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarTemplateConfigs: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarTieredFeatures: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarValueListItems: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1RadarValueListItemsItem: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarValueLists: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1RadarValueListsValueList: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RealTimeNotificationSettings: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1Refunds: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1RefundsRefund: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReportingCompartmentCachedMetadataKeys: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ReportingExecuteMultiEntityReport: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReportingMultiEntityReportRunsMultiEntityReportRun: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReportingMultiEntityReportRunsMultiEntityReportRunResults: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReportingMultiEntityReportTypes: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ReportingMultiEntityReportTypesReportType: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReportingReportRuns: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ReportingReportRunsReportRun: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReportingReportTypes: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ReportingReportTypesReportType: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RequestLogs: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RequestLogsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReserveHolds: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ReserveHoldsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReservePlans: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ReservePlansId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReserveReleases: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ReserveReleasesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RetrieveEmbeddedFlags: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RetryPolicies: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1RetryPoliciesRetryPolicy: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RevenueRecognitionAccountingIntelligenceRevenueForecast: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RevenueRecognitionAccountingIntelligenceStatementsInsights: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RevenueRecognitionBundleStatus: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RevenueRecognitionContractsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RevenueRecognitionContractsIdLines: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1RevenueRecognitionDataImportJournalEntries: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1RevenueRecognitionFilterOptions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RevenueRecognitionOverviewRecommendation: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RevenueStudioCampaigns: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1RevenueStudioCampaignsCampaign: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RevenueStudioPaymentOptimizerPlatformPaymentMethodRecommendations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Reviews: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ReviewsReview: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RisaComplianceSurvey: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskAccountStatus: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskAddressValidate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskChallengesChallengeId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskDashboardFormsAllPayoutAccountsLinked: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskDashboardFormsByNameName: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskDashboardFormsRequirementId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskDashboardFormsValidationUrl: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskStripeVerifiedGetVerifiedStatus: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskStripeVerifiedInterventions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1RiskStripeVerifiedIsMerchantTopStartup: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskUiAccountStatusBanner: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskUiAccountStatusSuppressionExemptions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskUrlRequirementStatus: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Ruleset: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ScreenshareSessionToken: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SettingsAllowedSettlementCurrencies: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SettingsCustomerCashBalanceDefaultReconciliationMode: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SettingsDebitsFeatureInvitation: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SettingsDebitsSettlement: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SettingsFasterSettlement: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SettingsPlansAndFeesInvoiceHistoryDocuments: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SettingsSupportHistorySharingCanOptOutOfSharingSupportHistory: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SettingsUserSettlementCurrencies: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1SetupAttempts: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1SetupIntentsIntent: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ShippingRates: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ShippingRatesShippingRateToken: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaAssistantSessionIdChatHistory: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaIsMerchantSanctioned: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaOrganizationQueries: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1SigmaOrganizationQueriesCompartments: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaOrganizationQueriesOrganizationQuery: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaOrganizationQueriesOrganizationQueryDownload: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaOrganizationQueryFiles: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1SigmaOrganizationQueryFilesOrganizationQueryFile: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaOrganizationScheduledQueryRuns: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1SigmaOrganizationScheduledQueryRunsOrganizationScheduledQueryRunDownload: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaOrganizationSchema: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaQueries: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1SigmaQueriesReportingQuery: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaQueriesReportingQueryDownload: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaQueriesReportingQueryResults: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaReportingQueryFolders: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaScheduledQueries: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1SigmaScheduledQueriesScheduledQuery: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaScheduledQueryRuns: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1SigmaScheduledQueryRunsScheduledQueryRun: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaVisualizations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SingaporeCddSurveyEnabled: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Skus: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1SourcesSource: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1StartupPartners: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1StatementsMetadata: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1StripecliDevices: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1StripecliWebhookResponses: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1StripeDatabases: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1StripeDatabasesSdbId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1StripeDatabasesTables: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1StripeDataPipelineExportPlanRequirements: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1StripeDataPipelineExportPlans: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1StripeDataPipelineInviteEmail: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1StripeDataPipelineListParentExportPlans: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1StripeVerifiedStatus: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SubscriptionItems: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1Subscriptions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1SubscriptionSchedules: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1SubscriptionSchedulesSchedule: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SubscriptionsSubscriptionExposedId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TailorAppBuildVersion: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TailorAppBuildVersionId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TailorAppByPublicId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TailorAppId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TailorAppIdInstalls: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TailorBackendSecretAppId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TailorBackendSignature: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TailorExtensionPrototypeVersion: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TailorExtensionPrototypeVersions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TailorExtensionsForInterface: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TailorExtensionUsagesForApp: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TailorExtensionUsagesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TailorInstall: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TailorInstallId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TailorTermsAcceptanceByAccountMerchantIdValid: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaskRadarRuleMatchedAccounts: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxAvailableCountries: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TaxCodes: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TaxCodesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxCurrentPricing: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxDocuments: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TaxFilingEnrollmentApplications: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TaxFilingEnrollmentApplicationsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxFilingEnrollmentAvailabily: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxFilingEnrollmentPartnerAccountsFind: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxFilingEnrollmentsAndApplications: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TaxHeadOfficeAvailableLocations: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TaxJurisdictionFeaturesFiling: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxLocations: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TaxLocationsLocation: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxMerchantPricing: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxMonitoringThresholds: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxOnboardingAvailability: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxPaygoMerchantRegistrationsAndFilings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxPlatformSettingsRetrieve: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxProductSettingsTaxCodeAssistantSearch: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxProductSettingsTaxCodeAssistantSearchQueryId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxProductTaxMigrationsCurrentStateV2: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxProductTaxMigrationsMigrations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxRates: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TaxRatesTaxRate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxRegistrationApplications: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TaxRegistrationApplicationsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxRegistrationExternalUrl: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxRegistrationMerchantInfoCountry: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxRegistrations: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TaxRegistrationsAvailability: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxRegistrationsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxReportingFatcaCrsForm: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxSignupState: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalAccountGroupAccountGroupIdDeployments: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalAccountGroupAccountGroupIdDeploymentsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalAccountGroupAccountGroupIdDeviceAssets: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalAccountGroupAccountGroupIdDeviceAssetVersions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalAccountGroupAccountGroupIdDeviceDeployGroups: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalConfigurations: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalConfigurationsConfiguration: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalConfigurationsDerivedConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalDeployPlans: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalDeviceAssets: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalDeviceAssetsDeviceAsset: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalDeviceAssetVersions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalDeviceAssetVersionsDeviceAssetVersion: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalDeviceDeployBundles: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalDeviceDeployBundlesDeviceDeployBundle: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalDeviceDeployGroups: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalDeviceDeployGroupsDeployGroupDeployRules: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalDeviceDeployGroupsDeviceDeployGroup: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrderDevices: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrderDevicesHardwareOrderInfo: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrderDevicesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrders: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersAvailableCountries: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersAvailableProviders: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersCharacterLimits: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersConnectConfigurationsDefault: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersIdPaymentDetails: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersInvoicesPaginated: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersMerchantTaxIds: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersPreview: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersProductTypeGroups: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersProductTypesOrder: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersSplitName: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersStripeEntityPublishableKey: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersSupportedTaxIdCountries: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersValidateAddress: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersValidatedCalculatedOrderIntentId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersValidatedCalculatedOrderIntentIdPaymentDetails: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareShippingMethods: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalHardwareShippingMethodsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareSkus: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalHardwareSkusId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareSkusRetrieveByIds: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalLocationCapabilities: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalLocationCapabilitiesCapability: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalLocationCapabilitiesSearch: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalLocations: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalLocationsLocation: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalLocationsSearch: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalMerchantDeployableCountriesMerchantId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalMerchantP2peValues: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalReaders: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalReadersListDistinctDeviceTypes: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalReadersReader: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalReadersSearch: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalTerminalDetailsPayment: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalZones: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalZonesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersTestClocks: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TestHelpersTestClocksTestClock: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ThreeDSecureAuthentications: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1ThreeDSecureAuthenticationsAuthentication: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TokenBillingAiModelPrices: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TokenBillingSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TokensToken: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TopupEmbeddedEligibility: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TopupIncomingWireTransfer: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Topups: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TransferCurrencyMapping: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Transfers: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TreasuryCreditReversalsCreditReversal: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TreasuryDebitReversalsDebitReversal: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TreasuryFinancialAccounts: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TreasuryFinancialAccountsFinancialAccount: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TreasuryFinancialAccountsFinancialAccountFeatures: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TreasuryInboundTransfersId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TreasuryOutboundPayments: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TreasuryOutboundPaymentsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TreasuryOutboundTransfersOutboundTransfer: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TreasuryReceivedCreditsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TreasuryReceivedDebitsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TreasuryTransactions: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TreasuryTransactionsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1UnifiedCustomersList: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1UnifiedLightningCustomersList: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1UsageFeeSummary: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1UsersInvite: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1UsPaperChecksId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ValidUaConfigs: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1VerificationRequirementHintsBankAccount: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WaysToPayPaymentMethodsDefault: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WaysToPayPublishableKey: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WebhookEndpoints: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1WebhookEndpointsWebhookEndpoint: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WebhookEndpointsWebhookEndpointSecret: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchAccountResourceVersion: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchApiEnums: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchApikeys: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchApiRequests: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchApiRequestStats: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchApiRequestStatsMultiPeriod: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchCliAuthTokenStatus: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchCliDeviceName: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchCurrentUser: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchErrorGroups: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchEventDestinationStats: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchIntegrationMigrationsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchIntegrationMigrationsSourcesUsage: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchIntegrationMigrationsUsage: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchMissionControlMission: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchOwningMerchant: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchShellPreviewTree: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchStripecliWebhookSecret: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchTestingScenarios: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchVersionDataSeries: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchWebhookConversationBodies: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchWebhookConversations: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1WorkbenchWebhookEndpointStats: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchWebhookEventTypes: {
      nonNullable: false,
      schemaId: 'v1',
    }
  },
  mutations: {
    deleteV1AccountsAccountExternalAccountsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1AccountsAccountPersonsPerson: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1ApprovalsApprovalRulesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1AppsAppConnectionId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1ClimateProgram: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1ConnectAccountNotesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1ConnectInvitationInviteId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1ConnectPricingGroupsTemplatesPricingTemplate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1ConsoleConversationsConversationId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1ConsoleDebugPrompt: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1ConsoleMerchantContext: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1ConsoleSkills: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1CurrentUserProfileBackupEmail: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1CurrentUserProfileTrustedLocation: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1CustomDomainsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1CustomersCustomer: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1CustomersCustomerTaxExemptionsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1CustomersCustomerTaxIdsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1CustomerSegmentationChartsChart: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1CustomerSegmentationDashboardsDashboard: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1CustomerSegmentationSavedSegmentsSavedSegment: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1DataExplorerGroupsGroup: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1DataExplorerMetricsMetric: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1ExportExportId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1InvoicesInvoice: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1ManagedOperationsCampaignsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1NotesNote: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1PricesPrice: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1PricingConfigsPricingTypeSchemesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1ProductClassesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1ProductsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1ProductsProductFeaturesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1ProfilesFinancialAccountTransfersConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1RadarMerchantRulesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1RadarTemplateConfigs: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1RadarValueListItemsItem: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1RadarValueListsValueList: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1RevenueRecognitionDataImportJournalEntriesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1RevenueStudioCampaignsCampaign: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1RulesRule: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1SigmaOrganizationQueryFilesOrganizationQueryFile: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1SigmaQueriesReportingQuery: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1SigmaReportingQueryFoldersFolderId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1SigmaScheduledQueriesScheduledQuery: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1StripeDatabasesSdbId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1SubscriptionsSubscriptionExposedId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1TailorInstallId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1TaxFilingEnrollmentApplicationsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1TaxRegistrationApplicationsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1TerminalConfigurationsConfiguration: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1TerminalDeviceDeployGroupsDeviceDeployGroup: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1TerminalHardwareOrdersMerchantTaxIdsThorMerchantTaxId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1TerminalLocationsLocation: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1TerminalReadersReader: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1TerminalZonesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1TestHelpersTestClocksTestClock: {
      nonNullable: false,
      schemaId: 'v1',
    },
    deleteV1WebhookEndpointsWebhookEndpoint: {
      nonNullable: false,
      schemaId: 'v1',
    },
    putV1AccountSecurityAnomaliesIdUserEvaluation: {
      nonNullable: false,
      schemaId: 'v1',
    },
    putV1ExpressAccountAccountId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    putV1RadarTemplateConfigs: {
      nonNullable: false,
      schemaId: 'v1',
    },
    putV1RealTimeNotificationSettings: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v13pTaxProviderEnableEngine: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AadhaarPrivateImport: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AadhaarPrivateStart: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Account: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountBatchPersons: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1AccountEmailSettingsUpdateAccountEmailSetting: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountingJournalSummarizerConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountLinks: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountPersonsPersonIdDocComplete: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountPersonsPersonIdDocTestSubmit: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountPersonsPersonIdDocVerify: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Accounts: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountsAccount: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountsAccountBatchPersons: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1AccountsAccountCapabilitiesCapability: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountsAccountExternalAccounts: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountsAccountExternalAccountsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountsAccountInvoiceTaxInfoSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountsAccountLoginLinksWithRedirect: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountsAccountPersons: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountsAccountPersonsPerson: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountsAccountReject: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountSessionsClaim: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountSuggestions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AccountVerificationDocument: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AdaptivePricingDirectConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AdaptivePricingSubaccountConfigsPlatform: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AdaptivePricingTemplateConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AgenticCommerceAgentConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AgenticCommerceSellerConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ApplicationFeesIdRefunds: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Applications: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ApplicationsApplicationTokenIntent: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ApplicationsApplicationTokenSubmit: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ApplicationsApplicationTokenValidate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ApprovalsApprovalRequestsApproveId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ApprovalsApprovalRequestsDenyId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ApprovalsApprovalRulesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ApprovalsCreateApprovalRule: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ApprovalsDetectApprovalRuleConflict: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppsAppConnection: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppsAppEmbeddedKey: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppsAppEmbeddedSession: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppsAppIdChannels: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppsAppIdChannelsChannelIdPublish: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppsAppIdChannelsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppsAppIdDynamicClientApplicationsClientIdRevoke: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppsAppIdUpdate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppsInquiries: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppsInquiriesAppInquiryIdUpdate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppsInstalls: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppsInstallsIdUninstall: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AppsSecrets: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AtlasDeleteApplication: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AtlasFundraisingBoardConsentBoardMembers: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AtlasFundraisingBoardConsentTargetRaise: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AtlasGenerateFundraisingBoardConsent: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AtlasSafeAuthorizedSigner: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AtlasSafeInvestor: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AtlasSafeSafeIdUpdate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AtlasSafeSend: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AtlasSafeTerms: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AtlasSkipFundraisingBoardConsent: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AtlasVoidFundraisingBoardConsent: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AtlasVoidSafe: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AuthChallengesInitiate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AuthChallengesRequire: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1AuthChallengesValidate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BalanceSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BalanceTransfers: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BalanceTransfersBalanceTransfer: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BankAccountsSourceGenerateMicrodeposits: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BankingPrivateBankingTransactionsTransaction: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BankingPrivateTreasuryPayout: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BankingUnrestrictFinancialAccountFeature: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingAlerts: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingAlertsIdActivate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingAlertsIdArchive: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingAlertsIdDeactivate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingCreditGrants: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingCreditGrantsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingCreditGrantsIdExpire: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingCreditGrantsIdVoid: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingMerchantTags: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingMeterEvents: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingMeterMerchantSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingMeters: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingMetersId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingMetersIdDeactivate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingMetersIdReactivate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingOverviewMerchantSettingsVersion: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingOverviewUbbMerchantSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPolicies: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalAccessClientConfirmAccess: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalAccessClientSendAccess: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalConfigurations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalConfigurationsConfiguration: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalRefundPolicies: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BillingPortalRetentionFlows: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionBillingIntents: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionCustomersCustomer: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionCancelTypeType: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionReactivate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionRetentionCoupon: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionUpdatePaymentMethod: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionExpSubscriptionSubscriptionUpdateSubscription: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionInvoicesInvoicePaymentMethodTypes: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionLogout: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionPaymentIntents: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionPaymentIntentsPaymentIntentConfirm: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionPaymentMethodsPaymentMethod: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionPaymentMethodsPaymentMethodAllowRedisplay: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionPaymentMethodsPaymentMethodDetach: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionPaymentMethodsPaymentMethodRecovery: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionPricingPlanSubscriptionsPricingPlanSubscriptionIdCancel: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSetupIntents: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSetupIntentsSetupIntentConfirm: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSpecialPurposeSubscriptionsResume: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscription: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionCancel: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionCancellationReason: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionPause: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionPaymentMethodsPaymentMethod: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionReactivate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionRelease: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionRemovePaymentOverride: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionResume: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionRetainSubscriptionCustomer: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BillingPortalSessionsSessionSubscriptionsSubscriptionRetentionFlowSession: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BulkActionDisconnectFinancialConnectionsAccount: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BulkActionRequestFinancialConnectionsHostedRelink: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BulkOnboardingUpdateAccount: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BuyButtons: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1BuyButtonsBuyButton: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalActionRequiredId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalAdditionalUnderwritingRequest: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalAdditionalUnderwritingRequestsCancel: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1CapitalConnectContractSign: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalConnectEnableDefaultSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalConnectPartnerProgramsCreateOrUpdateFromBusinessIntents: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalEmbeddedAccountLinks: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalFinancingOffersFinancingOfferChargeOff: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalFinancingOffersFinancingOfferDeliverOffer: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalFinancingOffersFinancingOfferExpire: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalFinancingOffersFinancingOfferFullyRepay: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalFinancingOffersFinancingOfferMarkDelivered: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalFinancingOffersFinancingOfferMintDurableLink: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalFinancingOffersFinancingOfferPayout: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalFinancingOffersFinancingOfferRequestDisbursal: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalFinancingOffersFinancingOfferRevokeV2: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalFinancingOffersFinancingOfferUpgrade: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalFinancingOffersOnDemand: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalFinancingOffersTestMode: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalImports: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalImportsImportBundleTransition: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalLendingNetworkCreatePartnerApplicationWorkflow: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalMerchantSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalMultiDrawSubsequentDrawOffers: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalOfferApplicationsOfferApplication: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalOfferApplicationsOfferApplicationSubmit: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalOfferApplicationsOfferInitiate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalOffersOfferOfferDocuments: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalPlatformsMerchantSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalSbfeConsent: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CapitalYouLendAcceptanceWorkflow: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CashAdvancesCashAdvanceAccept: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CashAdvancesCashAdvancePaydowns: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ChargesCharge: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ChargesChargeCapture: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CheckoutSessions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CheckoutSessionsSession: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateAutogenDraftSettingsPublish: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateAutogenDraftSettingsUpdate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateAutogenLiveSettingsDisable: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateAutogenLiveSettingsEnable: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateBadge: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateBrandSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateConnectPlatformConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateOrders: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateOrdersOrder: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateOrdersOrderCancel: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateProgram: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateSignupState: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateSignupStateActivate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ClimateWaitlistEntry: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CloseOwnAccount: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CommunicationManagementAddEmailDestination: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CommunicationManagementAddSubscriptionRecipient: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CommunicationManagementBulkAddSubscriptionRecipient: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CommunicationManagementClearEmailDestinationBounce: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CommunicationManagementDeleteEmailDestination: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CommunicationManagementDeleteSubscriptionRecipient: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CommunicationManagementResendEmailDestinationVerification: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAccountGroupsCsv: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAccountGroupsCsvValidate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAccountNotes: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAccountNotesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAccountsV2Disconnect: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAccountsV2EnableAutoprojections: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAccountsV2EnableCustomerAutoprojections: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAccountsV2GateMerchantIntoBeta: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAccountsV2OptOut: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAccountsV2ProjectV1Customer: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAccountsV2RequestV2AccountsFasttrack: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAgenticCommerceConfigSubaccountConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAgenticCommerceConfigTemplateConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectAuthRequiresExternalAccountVerification: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectCommsCenterAccountsAccount: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectCommsCenterCsvValidation: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectCommsCenterPlatformCommunicationsTemplateOption: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectCommsCenterSendTestEmail: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectCommsCenterUpdateEmails: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectCommsCenterUrlsRoute: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectCompleteOnboarding: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectCreateDirectifySecret: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectCreateLoginLinks: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectExpressInstantPayouts: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectExpressUpdateTheme: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectExternalAccountChallengeChallengeToken: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectExternalAccountCode: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectExternalAccountCodeVerify: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectGrossSettlementConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectIdentityChallenge: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectIntegrationPlatformAttestationItem: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectInviteNewOwnerMerchant: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectionsDisconnectAccounts: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectionsLinkAccountSessions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectionsOffersOfferAccept: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectionsRecipientOnboardingConfiguration: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectionsTokens: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectNoCodeInstantPayoutsSubaccountConfigConnectedAccountId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectNoCodeInstantPayoutsTemplateConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectOnboardingInsightsEvents: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectPricingGroupsSubaccountPricingGroup: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectPricingGroupsTemplates: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectPricingGroupsTemplatesPricingTemplate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectReonboardingValidateCsv: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectResendVerificationEmail: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectResendVerificationPhone: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectRiskAndComplianceSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectSessionAuthAttempt: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectSessionAuthAttemptVerify: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectTransferExpressAccountOwnership: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectUseLegalEntityAllLegalEntity: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectUserUpdateEmail: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectUserUpdatePhoneNumber: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectUserUpdatePhoneNumberChallenge: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectVerifyPhone: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectW8W9CollectionW8: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectW8W9CollectionW8W9PlatformConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConnectW8W9CollectionW9: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Console: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConsoleAudio: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConsoleConversationsConversationIdRename: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConsoleDebugPrompt: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConsoleMerchantContext: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConsoleMerchantContextBackfill: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConsoleQueryCancel: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConsoleSkills: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ConsoleSkillsToggle: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ControlledContentEvent: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Coupons: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CreateCompliancePdf: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CreatePaymentsConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CreditNotes: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CryptoInternalPayinSessionConfirm: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CryptoInternalPayinSessionCryptoPayinSessionAllocateDepositAddress: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CryptoInternalPayinSessionPrepare: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CryptoInternalPayinSessionUpdate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CryptoInternalPersonLookup: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CryptoInternalPersonPopulate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CryptoInternalRelayQuote: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CryptoInternalSetupSessionCryptoSetupSessionConfirm: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CryptoInternalSetupSessionCryptoSetupSessionPrepare: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CryptoInternalSetupSessionCryptoSetupSessionUpdate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CurrentUserContactPhoneNumber: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CurrentUserContactPhoneNumberConfirm: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CurrentUserProfileBackupEmail: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CurrentUserProfileDeferredInterrupt: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CurrentUserProfileTrustedLocation: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomDomains: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomDomainsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Customers: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomersBlockedBillingAddressCountries: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomersCustomer: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomersCustomerCashBalance: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomersCustomerCashBalanceTransfers: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomersCustomerFundingInstructions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomersCustomerTaxExemptions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomersCustomerTaxExemptionsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomersCustomerTaxIds: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomerSegmentationCharts: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomerSegmentationChartsChart: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomerSegmentationDashboards: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomerSegmentationDashboardsDashboard: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomerSegmentationPromptToSql: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomerSegmentationSavedSegments: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1CustomerSegmentationSavedSegmentsSavedSegment: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DashboardFxQuotes: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DashboardMulticurrencySettlementBulkUpdate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DashboardOnboardingExistingMerchantSetup: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DashboardOnboardingStripeProfileOnboardingTaskSetup: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DashboardSettingsBillingMode: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DashboardSettingsBillingNotifications: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DashboardSettingsSubscriptionProration: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DashboardVolumeLimitIncreaseRequest: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DataExplorerGroups: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DataExplorerGroupsGroup: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DataExplorerMetrics: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DataExplorerMetricsMetric: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DataManagementImportSets: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DataManagementImportSetsIdArchive: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DataStudioStartSdpTrial: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DataStudioSubscribeTrial: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DebitAgreements: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputeEvidenceSubmissionsSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesDispute: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesDisputeClose: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesDisputeInternalEscalate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesInternalAutoRepresentmentSettingDirectConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesInternalAutoRepresentmentSettingSubaccountConfigsPlatform: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesInternalAutoRepresentmentSettingTemplateConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesInternalEvidenceLibraryUpsertRecord: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesInternalPreventionActivateEnrollment: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DisputesInternalPreventionUpdateMerchantSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1DomainVerifier: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EmbeddedAuthenticationLinks: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EmbeddedCheckScanningEphemeralKey: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EmbeddedCreateInstantPayout: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EmbeddedCreatePrefundingBalancePayout: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EmbeddedCreateStandardPayout: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EmbeddedPaymentEphemeralKey: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EmbeddedSurfaces: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EmbeddedThemeExtractor: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EnterpriseProjectsBulkPromoCodesEnqueue: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EntitlementsFeatures: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EntitlementsFeaturesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1EventsIdRetry: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Export: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FacilitatedCommercePermissionedKey: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FacilitatedCommercePermissionGrants: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FacilitatedCommercePermissionGrantsRevoke: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FacilitatedCommerceProducts: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FeeCreditsActivate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FileLinks: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FinancialConnectionsAccountsAccountDisconnect: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FinancialConnectionsAccountsAccountHostedRelink: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FlexLoansFlexLoanPaydowns: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FortunaUpdateInvoicingEligibility: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FrMealVouchersSiretInfo: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1FrMealVouchersSiretInfoId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1GiftCardsCards: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1GiftCardsCardsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1GiftCardsCardsValidate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1GiftCardsTransactions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1GlobalTaxReportingPlatformSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1GlobalTaxReportingReportReportId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1GuestCustomersGuestCustomerRedact: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1GuidedFlowGetOrCreateFlowId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1GuidedFlowNextStepId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IamRoleAssignmentsPrincipal: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IdentityVerificationEntityTypeCheck: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IdentityVerificationSessions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IdentityVerificationSessionsSession: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IdentityVerificationSessionsSessionCancel: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IdentityVerificationSessionsSessionRedact: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IdentityVerificationTemplates: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IdentityVerificationTemplatesTemplate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IdentityVerificationTemplatesTemplateActivate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IdentityVerificationTemplatesTemplateDeactivate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InternalRubyWriteFirst: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Inventories: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InventoriesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InventoriesIdAdjust: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InventoriesIdRestock: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InviteATeammate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Invoiceitems: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoiceRenderingTemplates: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoiceRenderingTemplatesTemplate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoiceRenderingTemplatesTemplateApply: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoiceRenderingTemplatesTemplateArchive: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoiceRenderingTemplatesTemplateUnarchive: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Invoices: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoicesInvoice: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoicesInvoiceAttachPayment: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoicesInvoiceAttachPaymentIntent: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoicesInvoiceDetachPayment: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoicesInvoiceFinalize: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoicesInvoiceMarkUncollectible: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoicesInvoicePay: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoicesInvoiceSend: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1InvoicesInvoiceVoid: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingAftenrollmentEnroll: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingAftenrollmentUnenroll: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingAuthorizationsAuthorization: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingCardholders: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingCardholdersCardholder: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingCardholdersCardholderRedact: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingCards: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingCardsCard: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingCardsCardInitiateApplePayWebProvisioning: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingCardsCardInitiateGooglePayWebProvisioning: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingCardsCardRedact: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingDisputes: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingDisputesDispute: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingDisputesDisputeSubmit: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingDualOnboardOntoFinancialAccountIssuingMastercard: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingOffboardTestProgram: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingOnboardingApplicationSubmit: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingOnboardOntoDirectFinancialAccountIssuing: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingPersonalizationDesigns: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingPersonalizationDesignsPersonalizationDesign: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingProgramsProgram: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingReceipts: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1IssuingTransactionsTransaction: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1LpmDashboardSettingsFinancingPackageDetailsUpdateAffirmPackage: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ManagedOperationsCampaigns: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ManagedOperationsCampaignsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ManagedPaymentsMerchantSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ManagedPaymentsTermsOfService: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1MulticaptchaSession: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1MyinfoPrivateImport: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1MyinfoPrivateStart: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Notes: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1NotesNote: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1OrdersIdFulfill: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaperChecksIdReconcile: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentIntents: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentIntentsIntent: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentIntentsIntentApplyCustomerBalance: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentIntentsIntentCancel: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentIntentsIntentCapture: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentIntentsIntentConfirm: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentLinks: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentLinksPaymentLink: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentLinksPaymentLinkCopy: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentLinksPaymentLinkLineItemsCopy: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentMethodConfigurationsConfiguration: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentMethodDomains: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentMethodDomainsPaymentMethodDomain: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentMethodDomainsPaymentMethodDomainValidate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentMethods: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentMethodsPaymentMethod: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentMethodsPaymentMethodDetach: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentOptimizerSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentOptimizerSettingsCancelTrial: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentOptimizerSettingsStartTrial: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentOrchestrationRoutingRoutingExtensionIdActivate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentOrchestrationRoutingRoutingExtensionIdDeactivate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentRecordsReportPayment: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PaymentsConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Payouts: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PayoutsPayout: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PayoutsSettingsBankToPayoutReconciliation: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PersonVerificationRequest: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PlatformExtension: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PlatformOnboardingVerificationSession: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PmonboardingPmonboardingFormConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PocDocumentValidationValidate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Prices: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PricesPrice: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PricingConfigsPricingTypeSchemes: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PricingTables: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1PricingTablesPricingTable: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProductCatalogTrialOffers: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProductClasses: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProductClassesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Products: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProductsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProductsIdCopy: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProductsProductFeatures: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProductSuggestions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Profiles: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProfilesFinancialAccountTransfersConfig: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProfilesFinancialAccountTransfersRecipient: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProfilesFlag: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProfilesNetworkId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ProvisioningMerchantPrepare: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Quotes: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1QuotesQuote: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1QuotesQuoteAccept: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1QuotesQuoteCancel: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1QuotesQuoteFinalize: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarApplyRiskPreference: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarCustomCountersConfiguration: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarMerchantRulesActivateRuleId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarMerchantRulesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarMerchantRulesMerchantRuleIdFanouts: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarMerchantRulesRadarGptSendMessage: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarPaymentEvaluations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarRiskControlUpdateSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarSendUnderAttackMessage: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarSmartThreedsUpdateSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarTemplateConfigs: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarValueListItems: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarValueListItemsItemRedact: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarValueLists: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RadarValueListsValueList: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Refunds: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RefundsRefund: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RefundsRefundCancel: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReportingMultiEntityReportRuns: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReportingReportRuns: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReserveHolds: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReserveHoldsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReservePlans: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReservePlansId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReservePlansIdDisable: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReserveReleases: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RetrieveMerchantCustomerMarketingPreferencesCapabilitySlug: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RetryPolicies: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RetryPoliciesRetryPolicy: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RevenueStudioCampaigns: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RevenueStudioCampaignsCampaign: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReviewsReviewApprove: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReviewsReviewAssign: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReviewsReviewClose: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ReviewsReviewForwardToWebhook: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RisaComplianceSurvey: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskChallengesCreateFinancialConnectionResponse: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskChallengesSaveProductDescriptionIfSufficient: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskChallengesStripeVerifiedAccept: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskDashboardForms: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskDashboardFormsByName: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskDefinedInterventionsGetOrCreate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskRequirements: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskStripeVerifiedCreateAndLinkSupportCase: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RiskUrlRequirementReevaluate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Rules: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1RulesRule: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ScaleSetupIntents: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SettingsCustomerCashBalanceDefaultReconciliationMode: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SettingsDebitsFeatureInvitation: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SettingsDebitsSettlement: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SettingsFasterSettlement: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SettingsTaxInfo: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SetupIntents: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SetupIntentsIntent: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ShardedOnboardingDeleteRequest: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ShardedOnboardingSubmitEmail: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ShareableMetrics: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1ShippingRates: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaAssistantMessage: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaOrganizationQueries: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaOrganizationQueriesOrganizationQueryCancel: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaOrganizationQueryFiles: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaOrganizationQueryFilesOrganizationQueryFile: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaOrganizationQueryFilesOrganizationQueryFileSubscribe: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaOrganizationQueryFilesOrganizationQueryFileUnsubscribe: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaQueries: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaQueriesReportingQueryExportToSdp: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaReportingQueryFolders: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaReportingQueryFoldersFolderId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaScheduledQueries: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaScheduledQueriesScheduledQuery: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaVisualizations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SigmaVisualizationsVisualizationId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1StripeDatabases: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1StripeDatabasesSdbId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1StripeDataPipelineActivateExportPlan: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1StripeDataPipelineCreateExportPlan: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1StripeDataPipelineDeactivateExportPlan: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1StripeDataPipelineUpdateContactEmail: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1StripeSyncCreateSheetsOauth: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1StripeVerifiedRequest: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Subscriptions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SubscriptionSchedules: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SubscriptionSchedulesSchedule: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SubscriptionSchedulesScheduleCancel: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SubscriptionSchedulesScheduleRelease: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SubscriptionsSubscriptionAttachCadence: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SubscriptionsSubscriptionExposedId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SubscriptionsSubscriptionMigrate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SubscriptionsSubscriptionPause: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SubscriptionsSubscriptionResume: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1SupportEmail: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TailorAppBuildVersionAppBuildVersionIdUpdate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TailorInstall: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TailorRotateBackendSecretPublicId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TailorTermsAcceptance: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxConnectorsShopifyOauthAuthorize: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxConnectorsShopifyOauthVerify: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxDocumentsChallenge1099Tin: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxDocumentsDownloadTypeToken: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxFilingEnrollmentApplications: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxFilingEnrollmentApplicationsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxFilingEnrollmentApplicationsIdSubmit: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxFilingEnrollmentApplicationsIdUpdateSubmitted: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxFilingEnrollmentPartnerAccountsCreate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxLocations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxOnboardingSettingsRetrieveOrCreate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxOnboardingSettingsUpdate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxPlatformSettingsUpdate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxProductSettingsTaxCodeAssistantAfterSave: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxProductSettingsTaxCodeAssistantFeedback: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxProductSettingsTaxCodeAssistantSearch: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxProductThresholdNotificationOptIn: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxProductThresholdNotificationPreferences: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxRegistrationApplications: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxRegistrationApplicationsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxRegistrationApplicationsIdSubmit: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxRegistrations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxRegistrationsId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxReportingFatcaCrsForm: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxSignupStateActivate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxSignupStateRetrieveOrCreate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TaxSignupStateUpdate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalAccountGroupAccountGroupIdDeployments: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalAccountGroupAccountGroupIdDeploymentsIdArchive: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalAccountGroupAccountGroupIdDeploymentsIdUnarchive: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalConfigurations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalConfigurationsConfiguration: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalConfigurationsConfigurationReportAdminMenuPasscodeViewed: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalDeployPlans: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalDeployPlansDeployPlanActivate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalDeployPlansDeployPlanAdvance: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalDeployPlansDeployPlanPause: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalDeviceAssets: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalDeviceAssetVersions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalDeviceDeployGroups: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalDeviceDeployGroupsDeviceDeployGroup: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersConnectConfigurationsDefault: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersConnectConfigurationsIdSkuCatalog: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersCreateValidatedCalculatedOrderAndPaymentIntent: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersHardwareOrderCancel: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersMerchantTaxIds: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareOrdersSkuNotificationSignup: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalHardwareWarrantyClaimsTerminalHardwareWarrantyClaimHardwareWarrantyClaimItems: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TerminalLocationCapabilitiesCapability: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalLocations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalLocationsLocation: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalReaders: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalReadersReader: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalReadersReaderAdminOperations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalReportsExternalCsvReportEmails: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalZones: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TerminalZonesId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersCapitalFinancingOffersFinancingOfferTransactionIntents: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersCapitalFinancingOffersFinancingOfferTransactions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersCapitalLineOfCreditCreateOrRefresh: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersCapitalTransactionIntentsTransactionIntentFail: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersCapitalTransactionIntentsTransactionIntentSettle: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersCapitalTransactionsTransactionReverse: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersClimateOrdersOrderDelay: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersClimateOrdersOrderDeliver: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersDelegatedCheckoutRequestedSessions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersDelegatedCheckoutRequestedSessionsRequestedSession: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersDelegatedCheckoutRequestedSessionsRequestedSessionConfirm: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersDemoMerchantIssue: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersIssuingAuthorizations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersIssuingAuthorizationsAuthorizationCapture: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersIssuingAuthorizationsAuthorizationExpire: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersIssuingAuthorizationsAuthorizationIncrement: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersIssuingAuthorizationsAuthorizationReverse: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersIssuingAuthorizationsExpireId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersIssuingCaptures: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersIssuingCardsCardShippingDeliver: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersIssuingCardsCardShippingFail: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersIssuingCardsCardShippingReturn: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersIssuingCardsCardShippingShip: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersIssuingPersonalizationDesignsPersonalizationDesignActivate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersIssuingPersonalizationDesignsPersonalizationDesignDeactivate: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersIssuingPersonalizationDesignsPersonalizationDesignReject: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersIssuingTransactionsCreateForceCapture: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersTerminalHardwareOrderDevicesCreateDevicesForOrder: {
      nonNullable: true,
      schemaId: 'v1',
    },
    v1TestHelpersTerminalHardwareOrdersHardwareOrderDeliver: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersTerminalHardwareOrdersHardwareOrderMarkReadyToShip: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersTerminalHardwareOrdersHardwareOrderMarkUndeliverable: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersTerminalHardwareOrdersHardwareOrderShip: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersTestClocks: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersTestClocksTestClock: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TestHelpersTestClocksTestClockAdvance: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TokenBillingSettings: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Tokens: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TopupAddFundsTicket: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Topups: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TopupSource: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Transfers: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TreasuryDebitReversals: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TreasuryFinancialAccountsFinancialAccount: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TreasuryFinancialAccountsFinancialAccountClose: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TreasuryInboundTransfers: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TreasuryOutboundPayments: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TreasuryOutboundTransfers: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1TreasuryRecipients: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1UpdateConnectInsightsDashboardConfigurationForUser: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1UpdateMerchantCustomerMarketingPreferencesCapabilitySlug: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1UserGetUserPhoneData: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1UserReversePhoneCode: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1UserReversePhoneCodeConfirm: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1UsPaperChecks: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1UsPaperChecksId: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WaysToPayPaymentMethodsDefault: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WaysToPayPaymentMethodSetupSessions: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WebhookEndpoints: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WebhookEndpointsWebhookEndpoint: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchAgenticCommerceTriggerCheckoutCancelWebhook: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchAgenticCommerceTriggerCheckoutCompleteWebhook: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchAgenticCommerceTriggerCheckoutCreateWebhook: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchAgenticCommerceTriggerCheckoutRetrieveWebhook: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchAgenticCommerceTriggerCheckoutUpdateWebhook: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchIntegationInsightsFeedback: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchIntegrationMigrations: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchIntegrationMigrationsIdExecuteStep: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchIntegrationMigrationsIdProgressStep: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchMissionControlExecuteTrigger: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchSendFeedback: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1WorkbenchStartTestDataDeletion: {
      nonNullable: false,
      schemaId: 'v1',
    },
    v1Ytd2025Metrics: {
      nonNullable: false,
      schemaId: 'v1',
    }
  }
} as const;

export default topLevelFields;
type QueryFields = keyof typeof topLevelFields.queries;
type QueryFieldsSet = {
  [K in QueryFields]: true;
};
declare global {
  interface TopLevelFields extends QueryFieldsSet {}
}
